import { useEffect } from 'react';
import { useRouteError } from 'react-router';
import { captureException } from '../lib/sentry';

export function RouteErrorBoundary() {
  const error = useRouteError();

  useEffect(() => {
    void captureException(error);
  }, [error]);

  return (
    <main role="alert" style={{ padding: '2rem 1rem', maxWidth: '40rem', marginInline: 'auto' }}>
      <h1>Well, that didn't wrap up nicely.</h1>
      <p>Something went wrong on our end.</p>
      <button type="button" onClick={() => window.location.reload()}>
        Try again
      </button>
    </main>
  );
}
